import React, { useEffect, useRef } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { useLanguage } from '../../../../contexts/LanguageContext';

const API_TO_LANGUAGE_KEY_MAP = {
    equnr: 'vehicleDetailInformation.fields.equnr',
    zlangu: 'vehicleDetailInformation.fields.zlangu',
    sasiNo: 'vehicleDetailInformation.fields.sasiNo',
    vinPsa: 'vehicleDetailInformation.fields.vinPsa',
    musteriNo: 'vehicleDetailInformation.fields.musteriNo',
    lotNo: 'vehicleDetailInformation.fields.lotNo',
    plakaNo: 'vehicleDetailInformation.fields.plakaNo',
    erisimKodu: 'vehicleDetailInformation.fields.erisimKodu',
    anahtarKodu: 'vehicleDetailInformation.fields.anahtarKodu',
    odisseKodu: 'vehicleDetailInformation.fields.odisseKodu',
    urunKodu: 'vehicleDetailInformation.fields.urunKodu',
    urunGrb: 'vehicleDetailInformation.fields.urunGrb',
    urunGrubu: 'vehicleDetailInformation.fields.urunGrubu',
    urunAciklama: 'vehicleDetailInformation.fields.urunAciklama',
    urunAciklamaUs: 'vehicleDetailInformation.fields.urunAciklamaUs',
    dil: 'vehicleDetailInformation.fields.dil',
    govdeNo: 'vehicleDetailInformation.fields.govdeNo',
    cizelgeNo: 'vehicleDetailInformation.fields.cizelgeNo',
    markasi: 'vehicleDetailInformation.fields.markasi',
    sanziman: 'vehicleDetailInformation.fields.sanziman',
    sinifi: 'vehicleDetailInformation.fields.sinifi',
    tip: 'vehicleDetailInformation.fields.tip',
    varyant: 'vehicleDetailInformation.fields.varyant',
    versiyon: 'vehicleDetailInformation.fields.versiyon',
    yakit: 'vehicleDetailInformation.fields.yakit',
    modelYil: 'vehicleDetailInformation.fields.modelYil',
    aracAgirlik: 'vehicleDetailInformation.fields.aracAgirlik',
    tamamlanmamisFiiliKutle: 'vehicleDetailInformation.fields.tamamlanmamisFiiliKutle',
    motorSno: 'vehicleDetailInformation.fields.motorSno',
    sanzimanSno: 'vehicleDetailInformation.fields.sanzimanSno',
    sanzimanSeriNoManuel: 'vehicleDetailInformation.fields.sanzimanSeriNoManuel',
    sanzumanSeriNoOtomatik: 'vehicleDetailInformation.fields.sanzumanSeriNoOtomatik',
    motorEcu: 'vehicleDetailInformation.fields.motorEcu',
    hidDireksiyonSno: 'vehicleDetailInformation.fields.hidDireksiyonSno',
    direkisyonTakviyeTipi: 'vehicleDetailInformation.fields.direkisyonTakviyeTipi',
    trtBandrol: 'vehicleDetailInformation.fields.trtBandrol',
    bsiSno: 'vehicleDetailInformation.fields.bsiSno',
    bsiLogiciel: 'vehicleDetailInformation.fields.bsiLogiciel',
    alternator: 'vehicleDetailInformation.fields.alternator',
    alternatorKayisi: 'vehicleDetailInformation.fields.alternatorKayisi',
    absEcu: 'vehicleDetailInformation.fields.absEcu',
    marsMotorSno: 'vehicleDetailInformation.fields.marsMotorSno',
    yakitDeposuSno: 'vehicleDetailInformation.fields.yakitDeposuSno',
    onGerdirmeSno: 'vehicleDetailInformation.fields.onGerdirmeSno',
    onAmortisorSag: 'vehicleDetailInformation.fields.onAmortisorSag',
    onAmortisorSol: 'vehicleDetailInformation.fields.onAmortisorSol',
    arkaAmortisorSag: 'vehicleDetailInformation.fields.arkaAmortisorSag',
    arkaAmortisorSol: 'vehicleDetailInformation.fields.arkaAmortisorSol',
    arkaAksBorusu: 'vehicleDetailInformation.fields.arkaAksBorusu',
    airBagSno: 'vehicleDetailInformation.fields.airBagSno',
    airbagYolcuSno: 'vehicleDetailInformation.fields.airbagYolcuSno',
    yanHavaYastigiSno: 'vehicleDetailInformation.fields.yanHavaYastigiSno',
    yolcuYanHavaYastigiSno: 'vehicleDetailInformation.fields.yolcuYanHavaYastigiSno',
    ikinciSiraKoltuk: 'vehicleDetailInformation.fields.ikinciSiraKoltuk',
    ucuncuSiraKoltuk: 'vehicleDetailInformation.fields.ucuncuSiraKoltuk',
    touchScreenSeriNo: 'vehicleDetailInformation.fields.touchScreenSeriNo',
    torpidoEkraniSeriNo: 'vehicleDetailInformation.fields.torpidoEkraniSeriNo',
    kondenser: 'vehicleDetailInformation.fields.kondenser',
    evaparator: 'vehicleDetailInformation.fields.evaparator',
    kompresor: 'vehicleDetailInformation.fields.kompresor',
    klimaUnitesiSeriNo: 'vehicleDetailInformation.fields.klimaUnitesiSeriNo',
    defrosterSeriNo: 'vehicleDetailInformation.fields.defrosterSeriNo',
    batarya1SeriNo: 'vehicleDetailInformation.fields.batarya1SeriNo',
    batarya2SeriNo: 'vehicleDetailInformation.fields.batarya2SeriNo',
    skfElFreniSeriNo: 'vehicleDetailInformation.fields.skfElFreniSeriNo',
    dcDcInverterSeriNo: 'vehicleDetailInformation.fields.dcDcInverterSeriNo',
    elektrikliMotorSeriNo: 'vehicleDetailInformation.fields.elektrikliMotorSeriNo',
    onboardChargeSeriNo: 'vehicleDetailInformation.fields.onboardChargeSeriNo',
    evcuSeriNo: 'vehicleDetailInformation.fields.evcuSeriNo',
    selenoidValfSeriNo: 'vehicleDetailInformation.fields.selenoidValfSeriNo',
    gazPedaliSno: 'vehicleDetailInformation.fields.gazPedaliSno',
    westinghouseSno: 'vehicleDetailInformation.fields.westinghouseSno',
    modemSeriNo: 'vehicleDetailInformation.fields.modemSeriNo',
    ipNo: 'vehicleDetailInformation.fields.ipNo',
    gsmSeriNo: 'vehicleDetailInformation.fields.gsmSeriNo',
    debriyajAltMrk: 'vehicleDetailInformation.fields.debriyajAltMrk',
    pinno: 'vehicleDetailInformation.fields.pinno',
    nofab: 'vehicleDetailInformation.fields.nofab',
    odiCheck: 'vehicleDetailInformation.fields.odiCheck',
    immobilKodu: 'vehicleDetailInformation.fields.immobilKodu',
    frekansNo: 'vehicleDetailInformation.fields.frekansNo',
    sifre: 'vehicleDetailInformation.fields.sifre',
    radyoGuvK: 'vehicleDetailInformation.fields.radyoGuvK',
    radyoSeriK: 'vehicleDetailInformation.fields.radyoSeriK',
    radyoPinKodu: 'vehicleDetailInformation.fields.radyoPinKodu',
    uzaktanKumandaSno: 'vehicleDetailInformation.fields.uzaktanKumandaSno',
    mobileyeMasterCam: 'vehicleDetailInformation.fields.mobileyeMasterCam',
    mobiliyeBridge1: 'vehicleDetailInformation.fields.mobiliyeBridge1',
    mobiliyeBridge2: 'vehicleDetailInformation.fields.mobiliyeBridge2',
    mobiliyeBridge3: 'vehicleDetailInformation.fields.mobiliyeBridge3',
    surfsightSeriNo: 'vehicleDetailInformation.fields.surfsightSeriNo',
    zfOpenmaticsEcuSn: 'vehicleDetailInformation.fields.zfOpenmaticsEcuSn',
    zfOpenmaticsEcuPn: 'vehicleDetailInformation.fields.zfOpenmaticsEcuPn',
    zfOpenmaticsEcuLan1: 'vehicleDetailInformation.fields.zfOpenmaticsEcuLan1',
    vccuUniteSeriNo: 'vehicleDetailInformation.fields.vccuUniteSeriNo',
    fogmakerAlgilayiciSeriNo: 'vehicleDetailInformation.fields.fogmakerAlgilayiciSeriNo',
    fogmakerSondurucuSeriNo: 'vehicleDetailInformation.fields.fogmakerSondurucuSeriNo',
    zr5SeriNo: 'vehicleDetailInformation.fields.zr5SeriNo',
    ioModulSeriNo: 'vehicleDetailInformation.fields.ioModulSeriNo',
    norevFileVersion: 'vehicleDetailInformation.fields.norevFileVersion',
    norevCalcDate: 'vehicleDetailInformation.fields.norevCalcDate',
    inventoryItemId: 'vehicleDetailInformation.fields.inventoryItemId',
    siraNo: 'vehicleDetailInformation.fields.siraNo',
    stratusFlag: 'vehicleDetailInformation.fields.stratusFlag',
    siraNoXtra: 'vehicleDetailInformation.fields.siraNoXtra',
    organizationId: 'vehicleDetailInformation.fields.organizationId',
    wipEntityId: 'vehicleDetailInformation.fields.wipEntityId',
    vespaOk: 'vehicleDetailInformation.fields.vespaOk',
    vespaTekrar: 'vehicleDetailInformation.fields.vespaTekrar',
    modulatorKodu: 'vehicleDetailInformation.fields.modulatorKodu',
    ecuReferansNo: 'vehicleDetailInformation.fields.ecuReferansNo',
    difransiyelNo: 'vehicleDetailInformation.fields.difransiyelNo',
    famNo: 'vehicleDetailInformation.fields.famNo',
    vespaGondermeTuru: 'vehicleDetailInformation.fields.vespaGondermeTuru',
    vespaVinPsa: 'vehicleDetailInformation.fields.vespaVinPsa',
    enjektor12: 'vehicleDetailInformation.fields.enjektor12',
    enjektor34: 'vehicleDetailInformation.fields.enjektor34',
    tamamlamaTar: 'vehicleDetailInformation.fields.tamamlamaTar',
    teslimTarihi: 'vehicleDetailInformation.fields.teslimTarihi',
    irsaliyeTarihi: 'vehicleDetailInformation.fields.irsaliyeTarihi',
    faturaTarihi: 'vehicleDetailInformation.fields.faturaTarihi',
    uretimTarihi: 'vehicleDetailInformation.fields.uretimTarihi',
    irsaliyeNo: 'vehicleDetailInformation.fields.irsaliyeNo',
    faturaNo: 'vehicleDetailInformation.fields.faturaNo',
    pompaNo: 'vehicleDetailInformation.fields.pompaNo',
    egzozThc2: 'vehicleDetailInformation.fields.egzozThc2',
    deliverStatuId: 'vehicleDetailInformation.fields.deliverStatuId',
    deliverStatu: 'vehicleDetailInformation.fields.deliverStatu',
    orderStatu: 'vehicleDetailInformation.fields.orderStatu',
    approveStatu: 'vehicleDetailInformation.fields.approveStatu',
    fCarLocationName: 'vehicleDetailInformation.fields.fCarLocationName',
    fBranchName: 'vehicleDetailInformation.fields.fBranchName',
    fBranchId: 'vehicleDetailInformation.fields.fBranchId',
    fBranchSiteId: 'vehicleDetailInformation.fields.fBranchSiteId',
    fOrderTypeDesc: 'vehicleDetailInformation.fields.fOrderTypeDesc',
    fCarVinno: 'vehicleDetailInformation.fields.fCarVinno',
    fCarSerialNo: 'vehicleDetailInformation.fields.fCarSerialNo',
    fCarPdiOk: 'vehicleDetailInformation.fields.fCarPdiOk',
    fOrderedDate: 'vehicleDetailInformation.fields.fOrderedDate',
    fRequestedDeliverDate: 'vehicleDetailInformation.fields.fRequestedDeliverDate',
    fInvoiceDate: 'vehicleDetailInformation.fields.fInvoiceDate',
    fPaymentTypeDesc: 'vehicleDetailInformation.fields.fPaymentTypeDesc',
    fMaturityDate: 'vehicleDetailInformation.fields.fMaturityDate',
    fOrderId: 'vehicleDetailInformation.fields.fOrderId',
    fErpOrderNumber: 'vehicleDetailInformation.fields.fErpOrderNumber',
    fOrderInvoiceId: 'vehicleDetailInformation.fields.fOrderInvoiceId',
    fOrderInvoiceDate: 'vehicleDetailInformation.fields.fOrderInvoiceDate',
    fOrderInvPrice: 'vehicleDetailInformation.fields.fOrderInvPrice',
    fOrderCurrencyCode: 'vehicleDetailInformation.fields.fOrderCurrencyCode',
    fOrderCarDeliverDate: 'vehicleDetailInformation.fields.fOrderCarDeliverDate',
    fOrderDeliverDate: 'vehicleDetailInformation.fields.fOrderDeliverDate',
    fOrderListPrice: 'vehicleDetailInformation.fields.fOrderListPrice',
    fRegistrationDate: 'vehicleDetailInformation.fields.fRegistrationDate',
    fStandartWarrantyKm: 'vehicleDetailInformation.fields.fStandartWarrantyKm',
    fStandartWarrantyMonth: 'vehicleDetailInformation.fields.fStandartWarrantyMonth',
    fBrandModel: 'vehicleDetailInformation.fields.fBrandModel',
    pypKod: 'vehicleDetailInformation.fields.pypKod',
    
};

const VehicleAccordionTabs = ({ data}) => {
    const { th } = useLanguage();
    const toast = useRef(null);
    const isAllFieldsEmpty = (obj) => {
        if (!obj || typeof obj !== 'object') return true;
        return Object.values(obj).every((value) => value === null || value === '');
    };

    useEffect(() => {
        if (!data || Object.values(data).every(isAllFieldsEmpty)) {
            toast.current?.show({
                severity: 'info',
                summary: th('vehicleDetailInformation.results.noDataSummary'),
                detail: th('vehicleDetailInformation.results.noDataDetail'),
                life: 3000
            });
        }
    }, [data, th]);

    const formatObjectToArray = (obj) => {
        return Object.entries(obj || {}).reduce((acc, [apiKey, value]) => {
            const languageKey = API_TO_LANGUAGE_KEY_MAP[apiKey];

            if (languageKey) {
                const translatedField = <strong>{th(languageKey)}</strong>;


                acc.push({
                    field: translatedField,
                    value
                });
            }

            return acc;
        }, []);
    };

    const renderTable = (obj) => {
        const rows = formatObjectToArray(obj);
        if (rows.length === 0) {
            return <p className="text-sm text-color-secondary">{th('vehicleDetailInformation.results.noDataMessage')}</p>;
        }
        return (
            <DataTable
                value={rows}
                responsiveLayout="scroll"
                size="small"
                scrollable 
                scrollHeight="400px" 
            >
                <Column field="field" header={th('vehicleDetailInformation.results.fieldHeader')} style={{ width: '40%' }} />
                <Column field="value" header={th('vehicleDetailInformation.results.valueHeader')} />
            </DataTable>
        );
    };

    
    if (!data) return <Toast ref={toast} />;

  return (
    <div>
      <Toast ref={toast} />
      <Accordion multiple className="mt-4">
        {!isAllFieldsEmpty(data.vehicleInformation) && (
          <AccordionTab header={th('vehicleDetailInformation.tabs.vehicleProduction')}>
            {renderTable(data.vehicleInformation)}
          </AccordionTab>
        )}
        {!isAllFieldsEmpty(data.vehicleComplianceInformation) && (
          <AccordionTab header={th('vehicleDetailInformation.tabs.vehicleCompliance')}>
            {renderTable(data.vehicleComplianceInformation)}
          </AccordionTab>
        )}
        {!isAllFieldsEmpty(data.vehicleLocationInformation) && (
          <AccordionTab header={th('vehicleDetailInformation.tabs.vehicleLocation')}>
            {renderTable(data.vehicleLocationInformation)}
          </AccordionTab>
        )}
        {!isAllFieldsEmpty(data.vehicleOrderInvoiceInformation) && (
          <AccordionTab header={th('vehicleDetailInformation.tabs.vehicleOrderInvoice')}>
            {renderTable(data.vehicleOrderInvoiceInformation)}
          </AccordionTab>
        )}
        {!isAllFieldsEmpty(data.configurationInfo) && (
          <AccordionTab header={th('vehicleDetailInformation.tabs.vehicleConfiguration')}>
            {renderTable(data.configurationInfo)}
          </AccordionTab>
        )}
      </Accordion>
    </div>
  );
};

export default VehicleAccordionTabs;
